import React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

interface ModalProgressProps {
    inProgress: boolean;
}

export function ModalProgress(props: ModalProgressProps) {
    const {inProgress} = props;

    return (
        <Backdrop
            sx={{
                background: "transparent",
                color: (theme) => theme.palette.primary.main,
                zIndex: (theme) => theme.zIndex.drawer + 1,
                display: "flex",
                flexDirection: "column"
            }}
            open={inProgress}
        >
            <CircularProgress size={80} color="inherit" />
        </Backdrop>
    );
}
